import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {Notebook as Component} from './Notebook';

function mapStateToProps(state) {
  return {
    currentSectionType: getCurrentSectionType(state),
    levelSelected: state.notebook.levelSelected
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Notebook = connect(mapStateToProps, mapDispatchToProps)(Component);

const getCurrentSection = ({notebook}) => notebook.currentSection;
const getCurrentSectionType = createSelector(
  [getCurrentSection],
  (currentSection) => (currentSection ? currentSection.title : '')
);
